import { Box, Button, Dialog, Typography, useTheme } from '@mui/material';
import { useState } from 'react';
import { tokens } from '../../../global/theme/tokens';
import FormHelperText from '../FormHelperText';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import ExoExplorer from '../../exo/ExoExplorer';
import ExoDialog from '../../exo/ExoDialog';
import LabeledBox from '../../special/LabeledBox';
import MediaPreview from '../../exo/explorer/MediaPreview';
import ClearIcon from '@mui/icons-material/Clear';

const TypeImage = ({
  updateValidationOnChange,
  dataCollection,
  field,
  errors,
  size,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const [open, setOpen] = useState(false);
  const [img, setImg] = useState('');

  function handleClickImage() {
    setOpen(!open);
  }

  const handleSelect = (image) => {
    updateValidationOnChange(field.key, image);
    setImg(image.temporaryUrl);
    handleClickImage();
  };

  const handleReset = () => {
    updateValidationOnChange(field.key, null);
  };

  return (
    <Box>
      <Box className="flex gap-2">
        <LabeledBox
          size={size}
          onClick={() => setOpen(true)}
          sx={dataCollection[field.key] && { padding: '5px 5px' }}
          className="w-full flex flex-wrap gap-2 items-center"
        >
          {dataCollection[field.key] && (
            <MediaPreview
              src={dataCollection[field.key]?.temporaryUrl}
              onlyIcons={false}
              size={size === 'small' ? '28px' : '41px'}
            />
          )}
          <Typography>{field.label}</Typography>
        </LabeledBox>

        {dataCollection[field.key] && (
          <Button
            onClick={handleReset}
            sx={{
              minWidth: 'unset',
              bgcolor: colors.bgInput,
              aspectRatio: '1/1',
              width: size === 'small' ? '40px' : '53px',
              height: size === 'small' ? '40px' : '53px',
              borderRadius: '10px',
              border: `1px solid transparent`,
              ':hover': {
                bgcolor: colors.error + '30',
                border: `1px solid ${colors.error}80`,
                color: colors.error,
              },
            }}
          >
            <ClearIcon />
          </Button>
        )}
      </Box>
      <ExoDialog open={open} onClose={() => setOpen(false)}>
        <ExoExplorer onSelect={handleSelect} />
      </ExoDialog>
    </Box>
  );
};

export default TypeImage;
